import { Directive } from '@angular/core';

/** Pulsing placeholder block. Size and radius come from the host element's classes. */
@Directive({
  selector: '[libSkeleton]',
  host: {
    class: 'block animate-pulse bg-neutral-200 motion-reduce:animate-none',
    'aria-hidden': 'true',
  },
})
export class SkeletonDirective {}
